import { Permission } from '@/lib/permissions/v1'

export enum UsageRouteName {
    Index = 'usage:index',
    Show = 'usage:show',
    Provider = 'usage:provider',
    Tariff = 'usage:tariff',
}

export default {
    path: '/usage',
    component: () => import('@/views/Index.vue'),
    children: [
        {
            path: '',
            name: UsageRouteName.Index,
            component: () => import('@/views/usage/Index.vue'),
            meta: {
                label: 'Usage',
                auth: true,
                permission: Permission.CompanyServiceUsageViewAny,
            },
        },
        {
            path: ':usageUuid/details',
            name: UsageRouteName.Show,
            component: () => import('@/views/usage/Index.vue'),
            meta: {
                label: 'Usage Details',
                auth: true,
                permission: Permission.CompanyServiceUsageView,
            },
        },
        {
            path: ':usageUuid/provider',
            name: UsageRouteName.Provider,
            component: () => import('@/views/usage/Index.vue'),
            meta: {
                label: 'Usage Provider',
                auth: true,
                permission: Permission.CompanyServiceUsageView,
            },
        },
        {
            path: ':usageUuid/tariff',
            name: UsageRouteName.Tariff,
            component: () => import('@/views/usage/Index.vue'),
            meta: {
                label: 'Usage Tariff',
                auth: true,
                permission: Permission.CompanyServiceUsageView,
            },
        },
    ],
}
